import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { MILLISECONDS_IN_MINUTE, MILLISECONDS_IN_SECOND } from "@/lib/format-date"
import { cn } from "@/lib/utils"
import { formatDurationToNow, getDurationToNowInHours } from "@/modules/waiting-room/helpers/get-duration-to-now"

interface AppointmentEditStatusIndicatorProps extends React.HTMLAttributes<HTMLDivElement> {
  lockedAt: string | null
}

const AppointmentEditStatusIndicator = ({ lockedAt, className }: AppointmentEditStatusIndicatorProps) => {
  const { t } = useTranslation()

  const [durationText, setDurationText] = useState<string>(lockedAt === null ? "" : formatDurationToNow(lockedAt))

  useEffect(() => {
    if (lockedAt === null) return

    const hour = getDurationToNowInHours(lockedAt)
    const delayInterval = hour > 0 ? MILLISECONDS_IN_MINUTE : MILLISECONDS_IN_SECOND

    const interval = setInterval(() => setDurationText(formatDurationToNow(lockedAt)), delayInterval)

    return () => clearInterval(interval)
  }, [lockedAt])

  return (
    <div data-testid="appointment-status-indicator" className={cn("truncate", className)}>
      {`${t("scheduling.waitingRoom.grid.editingSince")} ${durationText}`}
    </div>
  )
}

export { AppointmentEditStatusIndicator }
